function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "JOOR-Events---JAN-2021-Update",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Hover-State-Colors",
  transform: "translate(-513.000000, -424.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Premium-+-SEEK",
  transform: "translate(492.000000, 95.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Coming-Soon",
  transform: "translate(21.000000, 329.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15,0 L30,0 L30,0 L30,35 C30,43.2842712 23.2842712,50 15,50 C6.71572875,50 1.01453063e-15,43.2842712 0,35 L0,15 C-1.01453063e-15,6.71572875 6.71572875,1.52179594e-15 15,0 Z",
  id: "Rectangle",
  fill: "#5C7284"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#FFFFFF",
  x: 4,
  y: 4,
  width: 22,
  height: 42,
  rx: 11
}), /*#__PURE__*/React.createElement("g", {
  id: "Battery",
  transform: "translate(9.000000, 13.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  stroke: "#323E48",
  strokeWidth: 2,
  x: 1,
  y: 3,
  width: 10,
  height: 19,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#F7B500",
  x: 2,
  y: 4,
  width: 8,
  height: 17
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-18",
  fill: "#323E48",
  x: 4,
  y: 0,
  width: 4,
  height: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.5,7.5 C7.41398751,6.8119001 7,6.5 6.5,7 C6.16666667,7.33333333 5,9 3,12 C2.33333333,13 2.5,13.5 3.5,13.5 C4.5,13.5 5,13.5 5,13.5 L4,16.5 C3.66666667,18.5 4.16666667,18.6666667 5.5,17 C6.83333333,15.3333333 7.83333333,13.8333333 8.5,12.5 C9.16666667,11.5 9,11 8,11 C7,11 6.66666667,11 7,11 C7.39067499,9.12539994 7.55734166,7.95873327 7.5,7.5 Z",
  id: "Path-2",
  fill: "#FFFFFF"
}))))));

function SvgComingSoonBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "50px",
    viewBox: "0 0 30 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Coming Soon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComingSoonBadge);
export default __webpack_public_path__ + "static/media/coming-soon-badge.77984e05.svg";
export { ForwardRef as ReactComponent };